<!-- step 1 file dropper -->
<div>
    <div *ngIf="!isFileUploaded; else step2">
        <app-file-drop
            (fileEvent)="uploadFile($event)"
        >
        </app-file-drop>
    </div>
</div>

<!-- step 2 upload progress -->

<ng-template  #step2 >
    <div *ngIf="isProcessing; else step3" class="loader-container">
        <div class="header">
            <div class="header-icon-container">
                <mat-icon class="header-icon">dataset</mat-icon>
            </div>
            <div class="header-text">
                <h3>Processing References</h3>
            </div>
        </div>
        <div class="loader">
            <h3>Processing</h3>
            <mat-spinner diameter="80"></mat-spinner>
            <h4>Don't click off this screen</h4>
        </div>
    </div>
</ng-template>

<ng-template #step3>
    <div class="table-container">
        <div>
            <!-- header  -->
            <div class="header">
                <div class="header-icon-container">
                    <mat-icon class="header-icon">dataset</mat-icon>
                </div>
                <div class="header-text">
                    <h2>Bulk Recreate results</h2>
                </div>
            </div>
            <div class="mat-elevation-z8; table-div">
                <table mat-table matSort [dataSource]="dataSource">

                    <ng-container matColumnDef="reference">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Reference </th>
                    <td mat-cell *matCellDef="let element"> {{element.reference}} </td>
                    </ng-container>

                    <ng-container matColumnDef="status" mats>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
                    <td mat-cell *matCellDef="let element"> {{element.status}} </td>
                    </ng-container>

                    <ng-container matColumnDef="success">
                    <th mat-header-cell *matHeaderCellDef> Recreated </th>
                    <td mat-cell *matCellDef="let element"> {{element.success}} </td>
                    </ng-container>

                    <ng-container matColumnDef="messages">
                    <th mat-header-cell *matHeaderCellDef> Error Message </th>
                    <td mat-cell *matCellDef="let element"> {{element.messages}} </td>
                    </ng-container>

                    <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                    <td mat-cell *matCellDef="let element"> 
                        <div *ngIf="element.orderId">
                            <button mat-icon-button (click)="openInNewTab(element.orderId)"><mat-icon>remove_red_eye</mat-icon></button> 
                        </div>
                    </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
                </table>
            </div>
                <mat-paginator 
                    [length]="dataSource.data.length"
                    [pageSize]="10"
                    [pageSizeOptions]="[10]"
                    showFirstLastButtons>
                </mat-paginator>
        </div>
        <div>
            <div class="footer">
                <button class="primary-button; button" mat-button mat-dialog-close>Close</button>
            </div>
        </div>
    </div>
</ng-template>


